import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import { cricketApi } from '../services/cricketBaseQuery';
import staticSlice from '../services/staticSlice';

/**
 * Cricket Store - Lightweight store for Cricket app
 * No authentication-related slices needed
 */
export const cricketStore = configureStore({
  reducer: {
    [cricketApi.reducerPath]: cricketApi.reducer,
    static: staticSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(cricketApi.middleware),
})

setupListeners(cricketStore.dispatch)

export type CricketAppDispatch = typeof cricketStore.dispatch;
export type CricketRootState = ReturnType<typeof cricketStore.getState>;
